import React from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { diffInDaysReturnNumber } from "functions";
import ProfileDisplay from "components/styled/Profile_Display";
import Message from "components/message";

// move setup sub logic to here

const SummaryDetails = (props) => {
  const { messages, locale } = props;
  const FIELDS = [
    {
      label: messages.subscriptionSummary.labels.noActivePets[locale],
      value: returnData("noActivePets", props),
    },
    {
      label: messages.subscriptionSummary.labels.planDesc[locale],
      value: returnData("planDesc", props),
    },
    {
      label: messages.subscriptionSummary.labels.amountToPay[locale],
      value: returnData("amountToPay", props),
    },
    {
      label: messages.subscriptionSummary.labels.trialDaysRemaining[locale],
      value: returnData("trialDaysRemaining", props),
    },
  ];

  //if (!props.billing.billingDataFetched) return null;
  // Tämä on hyvä, mutta varmista että billingDataFetched on totta vain kun plans-objekti on oikeasti olemassa
if (!props.billing || !props.billing.billingDataFetched) return null;

  return (
    <>
      <Message info message={"subscriptionSummary"} />
      <ProfileDisplay fields={FIELDS} />
    </>
  );
};

const returnData = (label, { pets, user, messages, billing, locale }) => {
  // 1. TURVATARKISTUS: Jos kieltä tai viestejä ei ole, palautetaan tyhjä
  if (!locale || !messages) return "";

  const petNames = () => {
    if (pets && pets.profiles) {
      return _.map(pets.profiles, ({ petName }, i) => {
        return i === 0 ? petName : ` ${petName}`;
      });
    }
    return null;
  };

  const amountToPay = () => {
    // 2. TÄSSÄ OLI VIRHE: Varmistetaan että billingData ja plans ovat olemassa
    const pricing = billing?.billingData?.plans?.pricing;
    
    if (!pricing || !user?.subLevel) return "-";

    const currency = pricing.currency?.[locale] || "EUR";
    
    const options = {
      style: "currency",
      currency: currency,
    };

    // Tarkistetaan löytyykö subLevel (esim. 'premium') hinnoittelusta
    const planData = pricing[user.subLevel];
    if (!planData) return "-";

    const amount =
      planData.withDecimal.toLocaleString(locale, options) +
      (messages.plans?.labels?.perMonth?.[locale] || "");
    
    return amount;
  };

  const trialDaysRemaining = diffInDaysReturnNumber(user?.trialEnd);
  const prevSubDaysRemaining = diffInDaysReturnNumber(user?.subEnd);

  switch (label) {
    case "noActivePets":
      return `${pets?.numActivePets || 0} ${petNames()?.toString() || ""}`;
    case "planDesc":
      return user?.subLevel === "none"
        ? "-"
        : messages.plans?.labels?.[user.subLevel]?.[locale] || "-";
    case "amountToPay":
      const price = amountToPay();
      const dueSuffix = messages.subscriptionSummary?.labels?.dueWithTrialEnd?.[locale] || "";
      
      return (trialDaysRemaining > 0 || prevSubDaysRemaining > 0)
        ? `${price} ${dueSuffix}`
        : price;
    case "trialDaysRemaining":
      if (prevSubDaysRemaining > 0 && !user?.subscription && !user?.trialPeriod) {
        return prevSubDaysRemaining;
      }
      return user?.trialPeriod && trialDaysRemaining > 0 ? trialDaysRemaining : 0;
    default:
      return "";
  }
};
const mapStateToProps = (state) => {
  return {
    messages: {
      subscriptionSummary:
        state.intl.messages.containers.subscription.subscriptionSummary,
      plans: state.intl.messages.containers.subscription.plans,
    },
    locale: state.intl.locale,
    billing: state.reducers.billing,
    user: state.reducers.auth.user,
    pets: state.reducers.pets,
  };
};

export default connect(mapStateToProps)(SummaryDetails);
